<svg xmlns="http://www.w3.org/2000/svg" width="92" height="88" viewBox="0 0 92 88">
    <defs>
        <linearGradient id="dylaru2joa" x1="50%" x2="50%" y1="100%" y2="0%">
            <stop offset="0%" stop-color="#FFF"/>
            <stop offset="100%" stop-color="#FFF"/>
        </linearGradient>
        <linearGradient id="p23omw5tub" x1="50%" x2="50%" y1="41.129%" y2="66.71%">
            <stop offset="0%" stop-color="#D90338"/>
            <stop offset="100%" stop-color="#0069C4"/>
        </linearGradient>
    </defs>
    <g fill="none" fill-rule="evenodd">
        <g>
            <g>
                <path fill="url(#dylaru2joa)" stroke="#D9DDDF" stroke-width="2.25" d="M1.125 1.125H90.875V86.875H1.125z" transform="translate(-10 -13) translate(10 13)"/>
                <g transform="translate(-10 -13) translate(10 13) translate(7 17)">
                    <path fill="#313131" fill-rule="nonzero" d="M76.91 16.28H64.94v-1.14h5.7c.343 0 .57-.228.57-.57 0-.342-.227-.57-.57-.57h-6.27c-.341 0-.57.228-.57.57v12.54c0 .342.229.57.57.57h3.42c.343 0 .57-.228.57-.57v-6.27h8.55c.343 0 .57-.228.57-.57v-3.42c0-.342-.227-.57-.57-.57z"/>
                    <path fill="#313131" fill-rule="nonzero" d="M72.92 25.4c0-1.083 1.71-2.85 1.71-2.85s1.71 1.767 1.71 2.85c0 1.083-.854 1.71-1.71 1.71-.854 0-1.71-.627-1.71-1.71z"/>
                    <path stroke="#0069C4" stroke-dasharray="5" stroke-linecap="square" stroke-width="2.5" d="M31.3 27l25.126.125L56.3 6"/>
                    <path stroke="#0069C4" stroke-dasharray="5" stroke-linecap="square" stroke-width="2.5" d="M0 27L30.926 27.083" transform="rotate(-180 15.463 27.041)"/>
                    <path stroke="#0069C4" stroke-dasharray="5" stroke-linecap="square" stroke-width="2.5" d="M0 50.5L30.926 50.583" transform="rotate(-180 15.463 50.541)"/>
                    <path stroke="#D90338" stroke-linecap="square" stroke-width="2.5" d="M0.301 2.957L69.301 3.252 69.301 8.833"/>
                    <path stroke="#0069C4" stroke-linecap="square" stroke-width="2.5" d="M68.801 50.5L28.801 50.5"/>
                    <circle cx="46.132" cy="26.837" r="5.472" fill="#FFF" stroke="#313131" stroke-width="1.5"/>
                    <path stroke="#313131" stroke-linecap="square" stroke-width="1.4" d="M47.301 22L42.301 27 46.801 31.5"/>
                    <path fill="url(#p23omw5tub)" d="M13.801 0H32.801V54H13.801z"/>
                    <path stroke="#FFF" stroke-linecap="square" stroke-width="1.5" d="M14.801 53L31.801 2" opacity=".4"/>
                </g>
            </g>
        </g>
    </g>
</svg>
